import { styled } from "@mui/material/styles";
import { TextField as MuiTextField } from "@mui/material";

const TransparentTextField = styled(MuiTextField)(({ theme }) => ({
	flex: 1,
	outline: "none",
	border: "none",

	fieldset: {
		display: "none",
	},

	input: {
		fontSize: 16,
		fontWeight: 500,
		textAlign: "start",
		color: theme.palette.common.firstColor,
		padding: "10px 15px",

		[theme.breakpoints.down("md")]: {
			fontSize: 14,
		}
	},
}))

const TextField = styled(MuiTextField)(({ theme }) => ({
	flex: 1,
	borderRadius: 5,

	label: {
		color: theme.palette.common.firstColor,
		transform: `translate(15px, 10px) scale(1)`,

		"&.MuiFormLabel-filled": {
			transform: `translate(15px, -9px) scale(0.75)`,
		}
	},


	fieldset: {
		borderColor: `${theme.palette.common.firstBorder} !important`,
	},

	input: {
		fontSize: 16,
		fontWeight: 400,
		textAlign: "start",
		color: `${theme.palette.common.firstColor}`,
		padding: "10px 15px",

		[theme.breakpoints.down("md")]: {
			fontSize: 14,
		}
	},

	'& label.Mui-focused, &.base-filled>label': {
		color: theme.palette.common.firstColor,
		transform: `translate(15px, -9px) scale(0.75)`,
	},

	".Mui-focused fieldset": {
		borderWidth: "1px !important",
		borderColor: `${theme.palette.common.firstColor}c0 !important`,
	},

	".Mui-error fieldset": {
		borderColor: `${theme.palette.common.fourthColor} !important`,
	},

	"label.Mui-error, .Mui-error": {
		color: `${theme.palette.common.fourthColor} !important`,
	},
}))
export { TransparentTextField, TextField }
